<template>
  <div class="global-modal" v-if="show">
    <div class="global-modal-content">
      <img alt="global-modal-arrow" src="@/assets/images/icon_arrow.png" class="global-modal-arrow">
      <div class="global-modal-text-content">
        <div class="global-modal-text-content-line">
          <div class="global-modal-text-content-circle">1</div>
          <div class="global-modal-text-content-text">点击右上角的 <div class="global-modal-more-box"><img alt="global-modal-more" src="@/assets/images/icon_more.png" class="global-modal-more"></div>按钮</div>
        </div>
        <div class="global-modal-text-content-line">
          <div class="global-modal-text-content-circle">2</div>
          <div class="global-modal-text-content-text">选择 <div class="global-modal-more-box"><img alt="global-modal-browser" src="@/assets/images/icon_browser.png" class="global-modal-browser">在浏览器中打开</div></div>
        </div>
      </div>
    </div>
    <!-- modal content -->
  </div>
</template>

<script>
export default {
  props: ['show']
}
</script>

<style scoped lang="scss">
.global-modal{
  width: 100vw;
  height: 100vh;
  position: absolute;
  z-index: 99999;
  background-color: #00000060;
  overflow: hidden;
}

.global-modal-content{
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.global-modal-arrow{
  position: absolute;
  top: 20px;
  right: 6.7%;
  width: 65px;
  height: 166px;
}

.global-modal-text-content-line{
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  font-size: 16px;
}


.global-modal-text-content-circle{
  width: 25px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  border-radius: 50%;
  background-color: #BDA557;
  font-size: 16px;
  color: #fff;
}

.global-modal-text-content-text{
  display: flex;
  align-items: center;
}

.global-modal-more{
  height: 16px;
}
.global-modal-more-box{
  padding: 3px 13px;
  background-color: #090909;
  border: 1px solid #757164;
  text-align: center;
  margin-left: 10px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  line-height: normal;
}

.global-modal-browser{
  width: 19px;
  height: 19px;
  margin-right: 6px;
}

.global-modal-text-content{
  width: fit-content;
  margin: 195px auto 0;
}
</style>

